import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { generateVideoUrl } from "./generateVideoUrl";
import { generatePosterUrl } from "./generatePosterUrl";
import { useMatchMedia } from "../../../../../hooks";
import styles from "./index.css";

const CategoryHeaderMedia = ({ viewportCategory, categoryId }) => {
  const [isVideoPaused, setIsVideoPaused] = useState(false);
  const videoRef = useRef(null);
  const prefersReducedMotion = useMatchMedia("(prefers-reduced-motion)");

  useEffect(() => {
    if (prefersReducedMotion) {
      videoRef.current.pause();
      setIsVideoPaused(true);
    }
  }, [prefersReducedMotion, videoRef]);

  const togglePlayPause = () => {
    videoRef.current.paused
      ? videoRef.current.play()
      : videoRef.current.pause();
    setIsVideoPaused(prevState => !prevState);
  };

  const handleKeyPress = event => {
    if (event.key === "Enter" || event.key === " ") {
      togglePlayPause();
    }
  };

  return (
    <div className={styles.categoryHeaderMedia}>
      <video
        ref={videoRef}
        key={viewportCategory}
        className={styles.video}
        autoPlay
        loop
        muted
        playsInline
        src={generateVideoUrl(viewportCategory, categoryId)}
        poster={generatePosterUrl(viewportCategory, categoryId)}
      ></video>
      <div className={styles.videoOverlay}>
        <div
          className={styles.overlayButtonOutline}
          onClick={togglePlayPause}
          onKeyDown={handleKeyPress}
          role="button"
          tabIndex={0}
          aria-label={isVideoPaused ? "Play" : "Pause"}
        >
          <div
            className={classnames(styles.overlayButton, {
              [styles.play]: isVideoPaused,
              [styles.pause]: !isVideoPaused
            })}
          ></div>
        </div>
      </div>
    </div>
  );
};

CategoryHeaderMedia.propTypes = {
  categoryId: PropTypes.number.isRequired,
  viewportCategory: PropTypes.string.isRequired
};

export default CategoryHeaderMedia;
